/***
 * Model that represents Queue Notification
 */
import Backbone from 'backbone';

var QueueNotification = Backbone.Model.extend({
    backend: 'gcapi',

    urlRoot: '/device-service/devicemessage/message',

    idAttribute: 'messageId'
});

export default QueueNotification;
